'use client';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { responsiveBreakpointsPx } from '@/constants';
import { ContentCardGroupProps } from './ContentCard.type';
import { ContentCardGroupCarousel } from './ContentCardGroupCarousel';
import { ContentCardGroupGrid } from './ContentCardGroupGrid';

export default function ContentCardGroup(props: ContentCardGroupProps): React.JSX.Element {
    const { carouselUntilDesktopSize = false, isMobileSwipeable = true } = props;
    const isTabletOrSmaller = useMediaQuery(`(min-width: ${responsiveBreakpointsPx.lg}px)`);

    if (carouselUntilDesktopSize && !isTabletOrSmaller && isMobileSwipeable) {
        return <ContentCardGroupCarousel {...props} />;
    }

    return <ContentCardGroupGrid {...props} />;
}
